// redux/cartSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../Axios/index';

// Add product to cart
export const addToCart_db = createAsyncThunk(
  'cart/addToCart',
  async ({ productId, quantity }, { rejectWithValue }) => {
    console.log("product id"  ,productId)
    try {
      const response = await axios.post('/cart/addToCart', { productId, quantity });
      return response.data.cartItem;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add to cart');
    }
  }
);

// Get cart items
export const getCartItems_db = createAsyncThunk(
  'cart/getCartItems',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/cart/getCart');
      return response.data.cartItems;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch cart');
    }
  }
);

// Update product quantity in cart
export const updateCart_db = createAsyncThunk(
  'cart/updateCart',
  async ({ productId, quantity }, { rejectWithValue }) => {
    try {
      const response = await axios.put('/cart/updateCart', { productId, quantity });
      return response.data.cartItem;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update cart');
    }
  }
);

// Remove product from cart
export const removeFromCart_db = createAsyncThunk(
  'cart/removeFromCart',
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axios.delete('/cart/removeFromCart', { data: { productId } });
      return productId;  // We'll use the productId to remove from state
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to remove from cart');
    }
  }
);

// Clear cart
export const clearCart_db = createAsyncThunk(
  'cart/clearCart',
  async (_, { rejectWithValue }) => {
    try {
      await axios.delete('/cart/clearCart');
      return [];  // Reset the cart to an empty array
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to clear cart');
    }
  }
);

// Cart slice
const db_cartSlice = createSlice({
  name: 'db_cart',
  initialState: {
    dbCartItems: [],
    error: null,
    loading: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null; // Clear error manually
    },
  },
  extraReducers: (builder) => {
    builder
      // Add to cart
      .addCase(addToCart_db.pending, (state) => {
        state.loading = true;
      })
      .addCase(addToCart_db.fulfilled, (state, action) => {
        state.loading = false;
        const { productId, quantity } = action.payload;
        const item = state.dbCartItems.find(item => item.productId === productId);
        if (item) {
         item.quantity = quantity;
        }else{
            state.dbCartItems.push(action.payload);

        }
      })
      .addCase(addToCart_db.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Get cart items
      .addCase(getCartItems_db.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCartItems_db.fulfilled, (state, action) => {
        state.loading = false;
        state.dbCartItems = action.payload;
      })
      .addCase(getCartItems_db.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update cart
      .addCase(updateCart_db.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCart_db.fulfilled, (state, action) => {
        state.loading = false;
        const { productId, quantity } = action.payload;
        const item = state.dbCartItems.find(item => item.productId === productId);
        if (item) {
         item.quantity = quantity;
        }
      })
      .addCase(updateCart_db.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Remove from cart
      .addCase(removeFromCart_db.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeFromCart_db.fulfilled, (state, action) => {
        state.loading = false;
        state.dbCartItems = state.dbCartItems.filter(item => item.Product.id !== action.payload);
      })
      .addCase(removeFromCart_db.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Clear cart
      .addCase(clearCart_db.pending, (state) => {
        state.loading = true;
      })
      .addCase(clearCart_db.fulfilled, (state) => {
        state.loading = false;
        state.dbCartItems = [];
      })
      .addCase(clearCart_db.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = db_cartSlice.actions;
export default db_cartSlice.reducer;
